import React from 'react'
import moment from 'moment'

export const Date = ({dateTime}) => {
  const formattedDate = moment.utc(dateTime).format('MM/DD/YYYY');
  return (
    <span> {formattedDate}</span>
  )
}
